import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import NoteForm from "./NoteForm";
import useNewsAdminServer from "./useNewsAdminServer";
import {
    buildAdminNewsSlug,
    createAdminNote,
    createEmptyAdminDraft,
    fetchAllAdminNotes,
    formatAdminPublishDate,
} from "./api";
import { resolveAdminCategoryValue } from "./config";

function getDefaultDraft() {
    return {
        ...createEmptyAdminDraft(),
        category: "Desde Adentro",
    };
}

export default function FispTvAdminCreateNote() {
    const { server, serverResolved } = useNewsAdminServer();
    const [draft, setDraft] = useState(getDefaultDraft);
    const [allNotes, setAllNotes] = useState([]);
    const [feedback, setFeedback] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!serverResolved) {
            return undefined;
        }

        const controller = new AbortController();

        fetchAllAdminNotes(server, controller.signal)
            .then((items) => setAllNotes(items))
            .catch(() => setAllNotes([]));

        return () => controller.abort();
    }, [server, serverResolved]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFeedback(null);
        setSubmitting(true);

        try {
            const videoUrl = draft.videoUrl.trim();

            const payload = {
                titulo: draft.title.trim(),
                categoria: resolveAdminCategoryValue(draft.category) || draft.category.trim(),
                descripcion: draft.description.trim(),
                imagen: draft.image.trim(),
                imagenPortada: draft.coverImage.trim() || null,
                linkVideo: videoUrl || " ",
                cuerpoNota: draft.body,
                url: draft.slug.trim() || buildAdminNewsSlug(draft.title),
                fecha: formatAdminPublishDate(draft.publishDate, draft.publishTime),
                artRel1: "",
                artRel2: "",
                artRel3: "",
            };

            await createAdminNote(payload, server).catch((error) => {
                // Si el servidor responde con body no-JSON pero status OK, ignoramos el error de parseo
                if (error?.message && error.message.includes("No se pudo obtener")) {
                    throw error;
                }
            });

            setFeedback({ type: "success", message: "La nota se agregó correctamente. Recargando..." });

            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch {
            setFeedback({ type: "error", message: "No pudimos agregar la nota. Revisá los campos e intentá nuevamente." });
            setSubmitting(false);
        }
    };

    return (
        <AdminLayout title="Agregar nota">
            <NoteForm
                draft={draft}
                setDraft={setDraft}
                allNotes={allNotes}
                onSubmit={handleSubmit}
                submitLabel="Agregar nota"
                submitBusyLabel="Agregando..."
                submitting={submitting}
                disabled={!serverResolved}
                showSlugField={false}
                showImageUrlField={false}
                showRelatedFields={false}
                showPublishSummary={false}
                allowImageUploadOnly={true}
                feedback={feedback}
            />
        </AdminLayout>
    );
}
